import { types } from "../types/types";

const initialState = {
    demoVideo: null,
};

const demoVideoReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.DEMO_VIDEO:
            return {
                ...state,
                demoVideo: action.payload,
            };
        default:
            return { ...state };
    }
};

export default demoVideoReducer;
